import { Pipe, PipeTransform } from '@angular/core';
import { StatutEvenement } from '../evenements.interface';

@Pipe({
  name: 'evenementStatut',
  standalone: true,
})
export class EvenementStatutPipe implements PipeTransform {
  transform(statutEvenement: StatutEvenement): string {
    switch (statutEvenement) {
      case StatutEvenement.AControler:
        return 'A contrôler';
      case StatutEvenement.ARedditionner:
        return 'A redditionner';
      case StatutEvenement.Acompte:
        return 'Acompte';
      case StatutEvenement.AcompteEnCours:
        return 'Acompte en cours';
      case StatutEvenement.EnCours:
        return 'En cours';
      case StatutEvenement.Redditionne:
        return 'Redditionné';
      case StatutEvenement.Reverse:
        return 'Reversé';
      case StatutEvenement.GereManuellement:
        return 'Géré manuellement';
      default:
        return 'Erreur';
    }
  }
}
